import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Chip,
  Grid2,
} from "@mui/material";
import axios from "../../../../api/axiosConfig";

const MOCK_CITY = "نامشخص";
const MOCK_COACH = "سرمربی نامشخص";

function getDaysBetween(start, end) {
  // Dates are in Jalali format, but for demo, treat as YYYY/MM/DD
  const [sy, sm, sd] = start.split("/").map(Number);
  const [ey, em, ed] = end.split("/").map(Number);
  // Simple calculation, not accurate for Jalali months
  const startDate = new Date(sy, sm - 1, sd);
  const endDate = new Date(ey, em - 1, ed);
  return (
    Math.max(1, Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1) -
    1
  );
}

export default function ManagerCampSummary() {
  const [camps, setCamps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get("/Training/api/Training/GetTrainingCamp")
      .then((res) => {
        setCamps(
          res.data.map((camp) => ({
            ...camp,
            campLocation: camp.campLocation || MOCK_CITY,
            headCoachName: camp.headCoachName || MOCK_COACH,
          })),
        );
        setLoading(false);
      })
      .catch(() => {
        setError("خطا در دریافت اطلاعات اردوها");
        setLoading(false);
      });
  }, []);

  // Summarize data
  const totalCamps = camps.length;
  const cities = [...new Set(camps.map((c) => c.campLocation))];
  const disciplines = [...new Set(camps.map((c) => c.baseSportFieldName))];
  let avgDays = 0;
  if (totalCamps > 0) {
    const totalDays = camps.reduce(
      (sum, c) => sum + getDaysBetween(c.startDate, c.endDate),
      0,
    );
    avgDays = Math.round(totalDays / totalCamps);
  }

  let content;
  if (loading) {
    content = <CircularProgress sx={{ display: "block", mx: "auto", mt: 4 }} />;
  } else if (error) {
    content = (
      <Typography color="error" sx={{ mb: 2 }}>
        {error}
      </Typography>
    );
  } else {
    content = (
      <>
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#fff",
            marginBottom: 3,
            padding: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={2}>
            خلاصه اردوهای تمرینی
          </Typography>
          <Grid2 container spacing={2} alignItems="stretch">
            <Grid2 size={{ xs: 12, sm: 3 }} sx={{ display: "flex" }}>
              <Card sx={{ flex: 1, height: "100%" }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold">
                    تعداد کل اردوها
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {totalCamps}
                  </Typography>
                </CardContent>
              </Card>
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 3 }} sx={{ display: "flex" }}>
              <Card sx={{ flex: 1, height: "100%" }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold">
                    شهرهای برگزارکننده
                  </Typography>
                  <Box
                    sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}
                  >
                    {cities.map((city) => (
                      <Chip key={city} label={city} color="info" />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 3 }} sx={{ display: "flex" }}>
              <Card sx={{ flex: 1, height: "100%" }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold">
                    رشته‌های ورزشی
                  </Typography>
                  <Box
                    sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}
                  >
                    {disciplines.map((d) => (
                      <Chip key={d} label={d} color="success" />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 3 }} sx={{ display: "flex" }}>
              <Card sx={{ flex: 1, height: "100%" }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold">
                    میانگین مدت اردو (روز)
                  </Typography>
                  <Typography variant="h6" color="secondary">
                    {avgDays}
                  </Typography>
                </CardContent>
              </Card>
            </Grid2>
          </Grid2>
        </Box>
        {/* <Divider sx={{ my: 4 }} /> */}
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#fff",
            padding: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={2}>
            جزئیات اردوها
          </Typography>
          <Grid2 container spacing={2}>
            {camps.map((camp) => (
              <Grid2 size={{ xs: 12, sm: 6 }} key={camp.trainigCampId}>
                <Card sx={{ mb: 2 }}>
                  <CardContent>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {camp.campTitle}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      {camp.campDescription}
                    </Typography>
                    <Box
                      sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 1 }}
                    >
                      <Chip label={`شهر: ${camp.campLocation}`} />
                      <Chip label={`رشته: ${camp.baseSportFieldName}`} />
                      <Chip label={`تاریخ شروع: ${camp.startDate}`} />
                      <Chip label={`تاریخ پایان: ${camp.endDate}`} />
                      <Chip
                        label={`مدت: ${getDaysBetween(
                          camp.startDate,
                          camp.endDate,
                        )} روز`}
                      />
                      <Chip label={`سرمربی: ${camp.headCoachName}`} />
                      <Chip
                        label={camp.campStatus ? "فعال" : "غیرفعال"}
                        color={camp.campStatus ? "success" : "default"}
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </Box>
      </>
    );
  }
  return <Box dir="rtl">{content}</Box>;
}
